import React, { useState, useEffect } from 'react';
import HeaderMenuButton from "./HeaderMenuButton";
import HeaderMenuModal from "./HeaderMenuModal";
import { getPendingJoinRequests } from '../../actions/agencies';
import { getAgencyName } from '../../actions/users';
var Header = function (_a) {
    var title = _a.title, _b = _a.isGoogleConnected, isGoogleConnected = _b === void 0 ? false : _b, _c = _a.isFacebookConnected, isFacebookConnected = _c === void 0 ? false : _c;
    var _d = useState(false), menuOpen = _d[0], setMenuOpen = _d[1];
    var _e = useState([]), pendingRequests = _e[0], setPendingRequests = _e[1];
    var _f = useState(""), agencyName = _f[0], setAgencyName = _f[1];
    // Chama a API ao montar o Header
    useEffect(function () {
        getPendingJoinRequests()
            .then(function (requests) { return setPendingRequests(requests); })
            .catch(function () { return setPendingRequests([]); });
    }, []);
    // Busca o nome da agência ao montar o Header
    useEffect(function () {
        getAgencyName()
            .then(function (data) { return setAgencyName(data.agency_name); })
            .catch(function () { return setAgencyName(""); });
    }, []);
    var hasPendingRequests = pendingRequests.length > 0;
    return (React.createElement("header", { className: "flex flex-col items-center justify-center py-1 md:py-3 bg-gradient-to-r from-blue-500 to-green-400 shadow-lg relative pr-28 md:pr-36" },
        agencyName && React.createElement("div", { className: "w-full flex" },
            React.createElement("h5", { className: "text-sm flex-1 text-center font-medium text-white" }, agencyName)),
        React.createElement("h1", { className: "pl-6 text-2xl md:text-5xl font-extrabold tracking-wide text-white text-left md:text-center drop-shadow-lg truncate", title: title }, title),
        React.createElement("div", { className: "absolute right-8 top-1/2 -translate-y-1/2 flex items-center group z-30" },
            React.createElement(HeaderMenuButton, { showMenuButton: (isGoogleConnected || isFacebookConnected), onClick: function () { return setMenuOpen(function (open) { return !open; }); }, hasNotification: hasPendingRequests }),
            menuOpen && (React.createElement(HeaderMenuModal, { onClose: function () { return setMenuOpen(false); }, notifications: pendingRequests.map(function (req) { return ({
                    message: "Solicita\u00E7\u00E3o pendente para ag\u00EAncia #".concat(req.agency),
                    onClick: function () { return setMenuOpen(false); }
                }); }) })))));
};
export default Header;
